import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import CloseIcon from '@mui/icons-material/Close';

export const DialogStyled = styled(Dialog)(() => ({
  padding: 0
}));

export const TitleStyled = styled(Text)(({ theme }) => ({
  '@media screen and (orientation:landscape)': {
    color: theme.palette.text.primary
  }
}));

export const DialogTitleStyled = styled(DialogTitle)(() => ({
  padding: '16px 20px',
  position: 'relative',
  top: 0,
  left: 0,
  right: 0,
  height: '52px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '@media screen and (orientation:landscape)': {
    position: 'absolute',
    zIndex: 300,
    padding: '16px 40px'
  }
}));

export const ImageStyled = styled('img')(() => ({
  width: '100%',
  height: 'auto',
  '@media screen and (orientation:landscape)': {
    height: '100%'
  }
}));

export const CloseButtonStyled = styled(CloseIcon)(({ theme }) => ({
  '@media screen and (orientation:landscape)': {
    color: theme.palette.text.primary
  }
}));

export const DialogActionsStyled = styled(DialogActions)(() => ({
  width: '100%',
  padding: '16px',
  '@media screen and (orientation:landscape)': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '24px'
  }
}));

export const ActionBoxStyled = styled(Stack)(() => ({
  width: '100%',
  flexDirection: 'row',
  gap: '8px',
  justifyContent: 'center'
}));

export const ButtonStyled = styled(Button)(() => ({
  borderRadius: '16px',
  height: '56px',
  width: '100%',
  padding: '0 20px',
  border: 'none',
  boxShadow: 'none',
  '@media screen and (orientation:landscape)': {
    borderRadius: '14px',
    height: '46px',
    width: '160px'
  }
}));
